import { Input } from 'antd';
import { observer } from 'mobx-react';
import React from "react";
import TextFilter from "../../../stores/common/text-filter";
import './style.css';

const TextSearchFilter: React.FC<{ textFilter: TextFilter }> = ({ textFilter }) => {

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        textFilter.changeSearchText(event.target.value);
    }

    return (
        <div className="filter__item">
            <Input.Search placeholder="поиск по тексту" onChange={handleChange} value={textFilter.text}/>
        </div>
    );
};

export default observer(TextSearchFilter);